module.exports = __webpack_public_path__ + "static/img/fingerpost_order_5.0ac612b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_order_5.jpg
// module id = b2ct
// module chunks = 0